export default __webpack_public_path__ + "static/media/dcl.cd8a37c1.png";